import React, { useEffect, useRef } from 'react'
import './styles.scss'
import { config } from './config'
import {
  CarouselElement,
  CarouselElementInvisible
} from 'components/CarouselElement'
interface Props {
  elements: CarouselElement[]
  handleChange: (parameter: string, value: string | number | number[]) => void
  parameter: covidDoseParameter | 'all'
  desc: { t: string | JSX.Element; d?: string | JSX.Element }
  ismobile: boolean
  type?: 'Szenario' | 'Parameter'
  current?: string | number | number[]
  autoScroll?: boolean
}

export const Carousel = ({
  elements,
  handleChange,
  parameter,
  current,
  desc,
  ismobile,
  type = 'Parameter',
  autoScroll = true
}: Props) => {
  const { t, d } = desc
  const wrapperRef = useRef<HTMLDivElement>()
  const currentIdx = elements.findIndex(f => `${f.value}` === `${current}`)
  const [selectedIdx, setSelectedIdx] = React.useState(currentIdx)

  useEffect(() => {
    setSelectedIdx(currentIdx)
  }, [currentIdx])

  useEffect(() => {
    if (!wrapperRef.current) return
    autoScroll &&
      wrapperRef.current.scrollTo({
        left: 160 * selectedIdx,
        behavior: 'smooth'
      })
    elements[selectedIdx] &&
      handleChange(parameter, elements[selectedIdx].value)
  }, [selectedIdx])

  return (
    <div className={'Carousel' + (type === 'Szenario' ? ' szenario' : '')}>
      <div className='ui text container'>
        <div className='title'>{t}</div>
        {d && <div className='desc'>{d}</div>}
      </div>
      <div
        className='CarouselWrapper'
        ref={wrapperRef}
        onScroll={e => {
          const childs = e.target.childNodes
          childs.forEach((element, i) => {
            const box = element.getBoundingClientRect()
            const diftomiddle = Math.abs(
              box.x + box.width / 2 - Math.floor(window.innerWidth / 2)
            )

            const isActive = diftomiddle < config.snapThreshold
            if (isActive) {
              setSelectedIdx(i - 1)
            }
          })
        }}
      >
        {ismobile && <CarouselElementInvisible type={type} />}
        {elements &&
          elements.map((m, i) => {
            return (
              <React.Fragment key={i}>
                <CarouselElement
                  id={i}
                  selected={`${i}` === `${selectedIdx}`}
                  content={m}
                  parameter={parameter}
                  handleChange={handleChange}
                  ismobile={ismobile}
                  type={type}
                  autoScroll={autoScroll}
                />
              </React.Fragment>
            )
          })}
        {ismobile && <CarouselElementInvisible type={type} />}
      </div>
      <div className='dots'>
        {elements &&
          elements.map((m, i) => {
            return (
              <div
                key={i}
                className={`dot ${`${i}` === `${selectedIdx}` ? 'sel' : ''}`}
              />
            )
          })}
      </div>
    </div>
  )
}
